export const select = (theme) => ({
  /* Styles applied to the root element. */
  root: {},
  filled: {
    border: `2px solid ${theme.customPalette.neutralGr04}`,
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
  icon: {
    width: 24,
    height: 24,
  },
  disabled: {
    backgroundColor: theme.customPalette.neutralGr03,
  },
});
